
import disableContextmenu from './module/disableContextmenu.js';
import MyLazyLoad from './module/MyLazyLoad.js';
import MylistBtn from './module/MylistBtn02.js';

function loadArticle() {
	if(document.querySelector('.js-load-article') !== null) {
		const trigger = document.querySelector('.js-load-article');
		const hideTrigger = document.querySelector('.js-hide-article');
		const target = document.querySelector('.js-article-list');
	
		trigger.addEventListener('click', function(event) {
			event.preventDefault();
			target.classList.add('is-show');
			trigger.classList.add('is-hide');
			hideTrigger.classList.remove('is-hide');
		});
	
		hideTrigger.addEventListener('click', function(event) {
			event.preventDefault();
			target.classList.remove('is-show');
			trigger.classList.remove('is-hide');
			hideTrigger.classList.add('is-hide');
		});
	}
  
}




(function() {

	window.addEventListener('load', () => {

		loadArticle();

		setTimeout(() => {//ヘッダーなどの；読み込みが終わってから処理開始
				const myLazyLoad = new MyLazyLoad();
				myLazyLoad.start();
				disableContextmenu();
				objectFitImages();

		}, 0)

		setTimeout(() => {//ヘッダーなどの；読み込みが終わってから処理開始
				//星ボタンクリックのアクション
				if(document.querySelector('.js-star') !== null) {
					const mylistBtn = new MylistBtn();
				}
				
		}, 1000) 
	});
	const program = document.querySelector('.p-program-all');

	if(program) {
		let swiper, swiperBool;
		const breakPoint = 1100;

		window.addEventListener('load', () => {
		if (breakPoint > window.innerWidth) {
				swiperBool = false;
		} else {
				//createSwiper();
				swiperBool = true;
		}
		}, false);

		window.addEventListener('resize', () => {
		if (breakPoint > window.innerWidth && swiperBool) {
				//swiper.destroy(false, true);
				swiperBool = false;
		} else if (breakPoint <= window.innerWidth && !(swiperBool)) {
				//createSwiper();
				swiperBool = true;
		}
		}, false);

		function createSwiper() {
				let programSwipers = document.getElementsByClassName('p-program-all');
				for(let i = 0; i < programSwipers.length; i++) {
						swiper = new Swiper(programSwipers[i], {
								slidesPerView: 1.271,
								spaceBetween: 10,
								speed: 1000,
								touchStartPreventDefault: false,
								// Navigation arrows
								navigation: {
								nextEl: '.p-program__next',
								prevEl: '.p-program__prev',
								},
						});
				}
		
		}

		let programMores = document.getElementsByClassName('js-program-more');
		let programHide = document.getElementsByClassName('js-program-hide');
		for(let i = 0; i < programMores.length; i++) {
				programMores[i].addEventListener('click', function(){
						this.parentNode.parentNode.classList.add('is-hide');
						this.parentNode.parentNode.nextElementSibling.classList.add('is-show');
				});
		}

		for(let i = 0; i < programHide.length; i++) {
			programHide[i].addEventListener('click', function(){
					let targetPosition = this.parentNode.parentNode.parentNode.parentNode.getBoundingClientRect().top;
					targetPosition = targetPosition + window.pageYOffset;
					$("html, body").animate({scrollTop:targetPosition}, 400, "swing");
					this.parentNode.classList.remove('is-show');
					this.parentNode.previousElementSibling.classList.remove('is-hide');
			});
	}
		
	}

	


	

})(); 

